import { render, staticRenderFns } from "./RealStateLotForm.vue?vue&type=template&id=bf770a46&scoped=true"
import script from "./RealStateLotForm.vue?vue&type=script&lang=js"
export * from "./RealStateLotForm.vue?vue&type=script&lang=js"
import style0 from "./RealStateLotForm.vue?vue&type=style&index=0&id=bf770a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf770a46",
  null
  
)

export default component.exports